import PythonApi from '@/services/PythonApi'

export default {
  index() {
    return PythonApi().get('sites')
  },
  show(siteID) {
    return PythonApi().get(`sites/${siteID}`)
  },
  post(site) {
    return PythonApi().post('sites', site)
  },
  put(site) {
    return PythonApi().put(`sites/${site.site_id}`, site)
  },
  delete(siteID) {
    return PythonApi().delete(`sites/${siteID}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/SitesService.js